.warningBanner {
  position: relative;
  width: 100%;
  margin-bottom: 16px;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.warningContent {
  background: black;
  border-radius: 12px;
  padding: 14px 20px 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
}

.warningIcon {
  width: 24px;
  height: 24px;
  color: #b8860b;
  flex-shrink: 0;
}

.warningText {
  flex: 1;
  color: #ffffff;
}

.warningText strong {
  display: block;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}

.warningSubtext {
  font-size: 12px;
  color: #4a4a4a;
  margin: 0;
}

.closeButton {
  position: absolute;
  top: 8px;
  right: 8px;
  background: transparent;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.closeButton:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.closeButton svg {
  width: 18px;
  height: 18px;
  color:white;
}

@media (max-width: 768px) {
  .warningContent {
    padding: 12px 16px;
  }

  .warningIcon {
    width: 20px;
    height: 20px;
  }

  .warningText strong {
    font-size: 13px;
  }

  .warningSubtext {
    font-size: 11px;
  }

  .closeButton svg {
    width: 16px;
    height: 16px;
  }
}
